import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import classNames from 'classnames';
import { AvForm, AvField, AvGroup, AvInput, AvFeedback } from 'availity-reactstrap-validation';
import { Alert, Button, Modal, ModalHeader, ModalBody, Col, Row, Collapse, CustomInput, Label } from 'reactstrap';
import axios from 'axios';
import { orderBy } from 'lodash';
import { AvSelectField } from '../AvSelect';
import Help from '../../Buttons/Help';
import upcImage from './assets/upc.jpg';
import dateImage from './assets/date.jpg';
var validFileTypes = '.jpg, .jpeg, .png, .pdf, .gif';

var ConsumerAffairsForm = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ConsumerAffairsForm, _React$Component);

  function ConsumerAffairsForm(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      setTimeout(function () {
        _this.setState({
          formActive: true
        });
      }, 5000);
    });

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function () {
      _this.setState({
        success: !_this.state.success
      });
    });

    _defineProperty(_assertThisInitialized(_this), "throwError", function () {
      _this.setState({
        error: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "dismissError", function () {
      _this.setState({
        error: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleSpecificProduct", function () {
      _this.setState({
        specificProduct: !_this.state.specificProduct
      });
    });

    _defineProperty(_assertThisInitialized(_this), "validateAttachment", function (value) {
      if (value) {
        var fileInput = document.getElementById('attachment');
        var file = fileInput && fileInput.files ? fileInput.files[0] : null;

        if (file) {
          var extension = file.name.split('.');

          _this.setState({
            attachmentName: file.name
          });

          if (extension.length > 1 && validFileTypes.indexOf(extension[1]) < 0) {
            return "Please attach an allowed file type: " + validFileTypes;
          }

          if (file && file.size > 5242880) {
            return 'Please attach a file that is 5MB or less';
          }
        }
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "getFormData", function (object) {
      var formData = new FormData();
      Object.keys(object).forEach(function (key) {
        formData.append(key, object[key]);
      });
      return formData;
    });

    _defineProperty(_assertThisInitialized(_this), "handleFileUpload", function (event) {
      _this.setState({
        file: event.target.files
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (event, values, submit) {
      if (_this.state.formActive) {
        var uri = _this.props.formHandlerApiUri;

        var formData = _this.getFormData(values);

        if (_this.state.file && _this.state.file.length > 0) {
          formData.append('file', _this.state.file[0]);
        }

        _this.setState({
          submitting: true
        });

        var axiosConfig = {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Api-Key': _this.props.formHandlerApiKey
          }
        };
        axios.post(uri, formData, axiosConfig).then(function (response) {
          if (response.status === 200) {
            _this.dismissError();

            _this.toggleModal();

            _this.form && _this.form.reset();
          } else _this.throwError();

          _this.setState({
            submitting: false
          });
        }).catch(function () {
          _this.throwError();

          _this.setState({
            submitting: false
          });
        });
      } else return null;
    });

    _this.state = {
      success: false,
      error: false,
      formActive: false,
      specificProduct: false,
      isAttachmentValid: true,
      attachmentName: /*#__PURE__*/React.createElement("span", {
        className: "text-placeholder"
      }, "Attach File..."),
      submitting: false
    };
    return _this;
  }

  var _proto = ConsumerAffairsForm.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var states = [{
      value: 'AL',
      label: 'Alabama'
    }, {
      value: 'AK',
      label: 'Alaska'
    }, {
      value: 'AB',
      label: 'Alberta'
    }, {
      value: 'AZ',
      label: 'Arizona'
    }, {
      value: 'AA',
      label: 'Armed Forces Americas'
    }, {
      value: 'AR',
      label: 'Arkansas'
    }, {
      value: 'AE',
      label: 'Armed Forces Outside'
    }, {
      value: 'AP',
      label: 'Armed Forces Pacific'
    }, {
      value: 'BC',
      label: 'British Columbia'
    }, {
      value: 'CA',
      label: 'California'
    }, {
      value: 'CO',
      label: 'Colorado'
    }, {
      value: 'CT',
      label: 'Connecticut'
    }, {
      value: 'DE',
      label: 'Delaware'
    }, {
      value: 'DC',
      label: 'District of Columbia'
    }, {
      value: 'FL',
      label: 'Florida'
    }, {
      value: 'GA',
      label: 'Georgia'
    }, {
      value: 'GU',
      label: 'Guam'
    }, {
      value: 'HI',
      label: 'Hawaii'
    }, {
      value: 'ID',
      label: 'Idaho'
    }, {
      value: 'IL',
      label: 'Illinois'
    }, {
      value: 'IN',
      label: 'Indiana'
    }, {
      value: 'IA',
      label: 'Iowa'
    }, {
      value: 'KS',
      label: 'Kansas'
    }, {
      value: 'KY',
      label: 'Kentucky'
    }, {
      value: 'LA',
      label: 'Louisiana'
    }, {
      value: 'ME',
      label: 'Maine'
    }, {
      value: 'MB',
      label: 'Manitoba'
    }, {
      value: 'MD',
      label: 'Maryland'
    }, {
      value: 'MA',
      label: 'Massachusetts'
    }, {
      value: 'MI',
      label: 'Michigan'
    }, {
      value: 'MN',
      label: 'Minnesota'
    }, {
      value: 'MS',
      label: 'Mississippi'
    }, {
      value: 'MO',
      label: 'Missouri'
    }, {
      value: 'MT',
      label: 'Montana'
    }, {
      value: 'NE',
      label: 'Nebraska'
    }, {
      value: 'NV',
      label: 'Nevada'
    }, {
      value: 'NB',
      label: 'New Brunswick'
    }, {
      value: 'NH',
      label: 'New Hampshire'
    }, {
      value: 'NJ',
      label: 'New Jersey'
    }, {
      value: 'NM',
      label: 'New Mexico'
    }, {
      value: 'NL',
      label: 'Newfoundland'
    }, {
      value: 'NY',
      label: 'New York'
    }, {
      value: 'NC',
      label: 'North Carolina'
    }, {
      value: 'ND',
      label: 'North Dakota'
    }, {
      value: 'NT',
      label: 'Northwest Territories'
    }, {
      value: 'NS',
      label: 'Nova Scotia'
    }, {
      value: 'OH',
      label: 'Ohio'
    }, {
      value: 'ON',
      label: 'Ontario'
    }, {
      value: 'OK',
      label: 'Oklahoma'
    }, {
      value: 'OR',
      label: 'Oregon'
    }, {
      value: 'PA',
      label: 'Pennsylvania'
    }, {
      value: 'PE',
      label: 'Prince Edward Island'
    }, {
      value: 'PR',
      label: 'Puerto Rico'
    }, {
      value: 'QC',
      label: 'Quebec'
    }, {
      value: 'RI',
      label: 'Rhode Island'
    }, {
      value: 'SK',
      label: 'Saskatchewan'
    }, {
      value: 'SC',
      label: 'South Carolina'
    }, {
      value: 'SD',
      label: 'South Dakota'
    }, {
      value: 'TN',
      label: 'Tennessee'
    }, {
      value: 'TX',
      label: 'Texas'
    }, {
      value: 'UT',
      label: 'Utah'
    }, {
      value: 'VT',
      label: 'Vermont'
    }, {
      value: 'VA',
      label: 'Virginia'
    }, {
      value: 'WA',
      label: 'Washington'
    }, {
      value: 'WV',
      label: 'West Virginia'
    }, {
      value: 'YT',
      label: 'Yukon Territory'
    }, {
      value: 'WI',
      label: 'Wisconsin'
    }, {
      value: 'WY',
      label: 'Wyoming'
    }];
    var countries = [{
      value: 'Afghanistan',
      label: 'Afghanistan'
    }, {
      value: 'Albania',
      label: 'Albania'
    }, {
      value: 'Algeria',
      label: 'Algeria'
    }, {
      value: 'American Samoa',
      label: 'American Samoa'
    }, {
      value: 'Andorra',
      label: 'Andorra'
    }, {
      value: 'Angola',
      label: 'Angola'
    }, {
      value: 'Anguilla',
      label: 'Anguilla'
    }, {
      value: 'Antarctica',
      label: 'Antarctica'
    }, {
      value: 'Antigua and Barbuda',
      label: 'Antigua and Barbuda'
    }, {
      value: 'Argentina',
      label: 'Argentina'
    }, {
      value: 'Armenia',
      label: 'Armenia'
    }, {
      value: 'Aruba',
      label: 'Aruba'
    }, {
      value: 'Ascension Island',
      label: 'Ascension Island'
    }, {
      value: 'Australia',
      label: 'Australia'
    }, {
      value: 'Austria',
      label: 'Austria'
    }, {
      value: 'Azerbaijan',
      label: 'Azerbaijan'
    }, {
      value: 'Bahamas',
      label: 'Bahamas'
    }, {
      value: 'Bahrain',
      label: 'Bahrain'
    }, {
      value: 'Bangladesh',
      label: 'Bangladesh'
    }, {
      value: 'Barbados',
      label: 'Barbados'
    }, {
      value: 'Belarus',
      label: 'Belarus'
    }, {
      value: 'Belgium',
      label: 'Belgium'
    }, {
      value: 'Belize',
      label: 'Belize'
    }, {
      value: 'Benin',
      label: 'Benin'
    }, {
      value: 'Bermuda',
      label: 'Bermuda'
    }, {
      value: 'Bhutan',
      label: 'Bhutan'
    }, {
      value: 'Bolivia',
      label: 'Bolivia'
    }, {
      value: 'Bosnia and Herzegovina',
      label: 'Bosnia and Herzegovina'
    }, {
      value: 'Botswana',
      label: 'Botswana'
    }, {
      value: 'Bouvet Island',
      label: 'Bouvet Island'
    }, {
      value: 'Brazil',
      label: 'Brazil'
    }, {
      value: 'British Indian Ocean Territory',
      label: 'British Indian Ocean Territory'
    }, {
      value: 'British Virgin Islands',
      label: 'British Virgin Islands'
    }, {
      value: 'Brunei',
      label: 'Brunei'
    }, {
      value: 'Bulgaria',
      label: 'Bulgaria'
    }, {
      value: 'Burkina Faso',
      label: 'Burkina Faso'
    }, {
      value: 'Burundi',
      label: 'Burundi'
    }, {
      value: 'Cambodia',
      label: 'Cambodia'
    }, {
      value: 'Cameroon',
      label: 'Cameroon'
    }, {
      value: 'Canada',
      label: 'Canada'
    }, {
      value: 'Canary Islands',
      label: 'Canary Islands'
    }, {
      value: 'Cape Verde',
      label: 'Cape Verde'
    }, {
      value: 'Caribbean Netherlands',
      label: 'Caribbean Netherlands'
    }, {
      value: 'Cayman Islands',
      label: 'Cayman Islands'
    }, {
      value: 'Central African Republic',
      label: 'Central African Republic'
    }, {
      value: 'Ceuta and Melilla',
      label: 'Ceuta and Melilla'
    }, {
      value: 'Chad',
      label: 'Chad'
    }, {
      value: 'Chile',
      label: 'Chile'
    }, {
      value: 'China',
      label: 'China'
    }, {
      value: 'Christmas Island',
      label: 'Christmas Island'
    }, {
      value: 'Clipperton Island',
      label: 'Clipperton Island'
    }, {
      value: 'Cocos [Keeling] Islands',
      label: 'Cocos [Keeling] Islands'
    }, {
      value: 'Colombia',
      label: 'Colombia'
    }, {
      value: 'Comoros',
      label: 'Comoros'
    }, {
      value: 'Congo - Brazzaville',
      label: 'Congo - Brazzaville'
    }, {
      value: 'Congo - Kinshasa',
      label: 'Congo - Kinshasa'
    }, {
      value: 'Cook Islands',
      label: 'Cook Islands'
    }, {
      value: 'Costa Rica',
      label: 'Costa Rica'
    }, {
      value: 'Croatia',
      label: 'Croatia'
    }, {
      value: 'Cuba',
      label: 'Cuba'
    }, {
      value: 'Curaçao',
      label: 'Curaçao'
    }, {
      value: 'Cyprus',
      label: 'Cyprus'
    }, {
      value: 'Czech Republic',
      label: 'Czech Republic'
    }, {
      value: 'Côte d’Ivoire',
      label: 'Côte d’Ivoire'
    }, {
      value: 'Denmark',
      label: 'Denmark'
    }, {
      value: 'Diego Garcia',
      label: 'Diego Garcia'
    }, {
      value: 'Djibouti',
      label: 'Djibouti'
    }, {
      value: 'Dominica',
      label: 'Dominica'
    }, {
      value: 'Dominican Republic',
      label: 'Dominican Republic'
    }, {
      value: 'Ecuador',
      label: 'Ecuador'
    }, {
      value: 'Egypt',
      label: 'Egypt'
    }, {
      value: 'El Salvador',
      label: 'El Salvador'
    }, {
      value: 'Equatorial Guinea',
      label: 'Equatorial Guinea'
    }, {
      value: 'Eritrea',
      label: 'Eritrea'
    }, {
      value: 'Estonia',
      label: 'Estonia'
    }, {
      value: 'Ethiopia',
      label: 'Ethiopia'
    }, {
      value: 'Falkland Islands',
      label: 'Falkland Islands'
    }, {
      value: 'Faroe Islands',
      label: 'Faroe Islands'
    }, {
      value: 'Fiji',
      label: 'Fiji'
    }, {
      value: 'Finland',
      label: 'Finland'
    }, {
      value: 'France',
      label: 'France'
    }, {
      value: 'French Guiana',
      label: 'French Guiana'
    }, {
      value: 'French Polynesia',
      label: 'French Polynesia'
    }, {
      value: 'French Southern Territories',
      label: 'French Southern Territories'
    }, {
      value: 'Gabon',
      label: 'Gabon'
    }, {
      value: 'Gambia',
      label: 'Gambia'
    }, {
      value: 'Georgia',
      label: 'Georgia'
    }, {
      value: 'Germany',
      label: 'Germany'
    }, {
      value: 'Ghana',
      label: 'Ghana'
    }, {
      value: 'Gibraltar',
      label: 'Gibraltar'
    }, {
      value: 'Greece',
      label: 'Greece'
    }, {
      value: 'Greenland',
      label: 'Greenland'
    }, {
      value: 'Grenada',
      label: 'Grenada'
    }, {
      value: 'Guadeloupe',
      label: 'Guadeloupe'
    }, {
      value: 'Guam',
      label: 'Guam'
    }, {
      value: 'Guatemala',
      label: 'Guatemala'
    }, {
      value: 'Guernsey',
      label: 'Guernsey'
    }, {
      value: 'Guinea',
      label: 'Guinea'
    }, {
      value: 'Guinea-Bissau',
      label: 'Guinea-Bissau'
    }, {
      value: 'Guyana',
      label: 'Guyana'
    }, {
      value: 'Haiti',
      label: 'Haiti'
    }, {
      value: 'Heard Island and McDonald Islands',
      label: 'Heard Island and McDonald Islands'
    }, {
      value: 'Honduras',
      label: 'Honduras'
    }, {
      value: 'Hong Kong SAR China',
      label: 'Hong Kong SAR China'
    }, {
      value: 'Hungary',
      label: 'Hungary'
    }, {
      value: 'Iceland',
      label: 'Iceland'
    }, {
      value: 'India',
      label: 'India'
    }, {
      value: 'Indonesia',
      label: 'Indonesia'
    }, {
      value: 'Iran',
      label: 'Iran'
    }, {
      value: 'Iraq',
      label: 'Iraq'
    }, {
      value: 'Ireland',
      label: 'Ireland'
    }, {
      value: 'Isle of Man',
      label: 'Isle of Man'
    }, {
      value: 'Israel',
      label: 'Israel'
    }, {
      value: 'Italy',
      label: 'Italy'
    }, {
      value: 'Jamaica',
      label: 'Jamaica'
    }, {
      value: 'Japan',
      label: 'Japan'
    }, {
      value: 'Jersey',
      label: 'Jersey'
    }, {
      value: 'Jordan',
      label: 'Jordan'
    }, {
      value: 'Kazakhstan',
      label: 'Kazakhstan'
    }, {
      value: 'Kenya',
      label: 'Kenya'
    }, {
      value: 'Kiribati',
      label: 'Kiribati'
    }, {
      value: 'Kosovo',
      label: 'Kosovo'
    }, {
      value: 'Kuwait',
      label: 'Kuwait'
    }, {
      value: 'Kyrgyzstan',
      label: 'Kyrgyzstan'
    }, {
      value: 'Laos',
      label: 'Laos'
    }, {
      value: 'Latvia',
      label: 'Latvia'
    }, {
      value: 'Lebanon',
      label: 'Lebanon'
    }, {
      value: 'Lesotho',
      label: 'Lesotho'
    }, {
      value: 'Liberia',
      label: 'Liberia'
    }, {
      value: 'Libya',
      label: 'Libya'
    }, {
      value: 'Liechtenstein',
      label: 'Liechtenstein'
    }, {
      value: 'Lithuania',
      label: 'Lithuania'
    }, {
      value: 'Luxembourg',
      label: 'Luxembourg'
    }, {
      value: 'Macau SAR China',
      label: 'Macau SAR China'
    }, {
      value: 'Macedonia',
      label: 'Macedonia'
    }, {
      value: 'Madagascar',
      label: 'Madagascar'
    }, {
      value: 'Malawi',
      label: 'Malawi'
    }, {
      value: 'Malaysia',
      label: 'Malaysia'
    }, {
      value: 'Maldives',
      label: 'Maldives'
    }, {
      value: 'Mali',
      label: 'Mali'
    }, {
      value: 'Malta',
      label: 'Malta'
    }, {
      value: 'Marshall Islands',
      label: 'Marshall Islands'
    }, {
      value: 'Martinique',
      label: 'Martinique'
    }, {
      value: 'Mauritania',
      label: 'Mauritania'
    }, {
      value: 'Mauritius',
      label: 'Mauritius'
    }, {
      value: 'Mayotte',
      label: 'Mayotte'
    }, {
      value: 'Mexico',
      label: 'Mexico'
    }, {
      value: 'Micronesia',
      label: 'Micronesia'
    }, {
      value: 'Moldova',
      label: 'Moldova'
    }, {
      value: 'Monaco',
      label: 'Monaco'
    }, {
      value: 'Mongolia',
      label: 'Mongolia'
    }, {
      value: 'Montenegro',
      label: 'Montenegro'
    }, {
      value: 'Montserrat',
      label: 'Montserrat'
    }, {
      value: 'Morocco',
      label: 'Morocco'
    }, {
      value: 'Mozambique',
      label: 'Mozambique'
    }, {
      value: 'Myanmar [Burma]',
      label: 'Myanmar [Burma]'
    }, {
      value: 'Namibia',
      label: 'Namibia'
    }, {
      value: 'Nauru',
      label: 'Nauru'
    }, {
      value: 'Nepal',
      label: 'Nepal'
    }, {
      value: 'Netherlands',
      label: 'Netherlands'
    }, {
      value: 'Netherlands Antilles',
      label: 'Netherlands Antilles'
    }, {
      value: 'New Caledonia',
      label: 'New Caledonia'
    }, {
      value: 'New Zealand',
      label: 'New Zealand'
    }, {
      value: 'Nicaragua',
      label: 'Nicaragua'
    }, {
      value: 'Niger',
      label: 'Niger'
    }, {
      value: 'Nigeria',
      label: 'Nigeria'
    }, {
      value: 'Niue',
      label: 'Niue'
    }, {
      value: 'Norfolk Island',
      label: 'Norfolk Island'
    }, {
      value: 'Northern Mariana Islands',
      label: 'Northern Mariana Islands'
    }, {
      value: 'North Korea',
      label: 'North Korea'
    }, {
      value: 'Norway',
      label: 'Norway'
    }, {
      value: 'Oman',
      label: 'Oman'
    }, {
      value: 'Outlying Oceania',
      label: 'Outlying Oceania'
    }, {
      value: 'Pakistan',
      label: 'Pakistan'
    }, {
      value: 'Palau',
      label: 'Palau'
    }, {
      value: 'Palestinian Territories',
      label: 'Palestinian Territories'
    }, {
      value: 'Panama',
      label: 'Panama'
    }, {
      value: 'Papua New Guinea',
      label: 'Papua New Guinea'
    }, {
      value: 'Paraguay',
      label: 'Paraguay'
    }, {
      value: 'Peru',
      label: 'Peru'
    }, {
      value: 'Philippines',
      label: 'Philippines'
    }, {
      value: 'Pitcairn Islands',
      label: 'Pitcairn Islands'
    }, {
      value: 'Poland',
      label: 'Poland'
    }, {
      value: 'Portugal',
      label: 'Portugal'
    }, {
      value: 'Puerto Rico',
      label: 'Puerto Rico'
    }, {
      value: 'Qatar',
      label: 'Qatar'
    }, {
      value: 'Romania',
      label: 'Romania'
    }, {
      value: 'Russia',
      label: 'Russia'
    }, {
      value: 'Rwanda',
      label: 'Rwanda'
    }, {
      value: 'Réunion',
      label: 'Réunion'
    }, {
      value: 'Saint Barthélemy',
      label: 'Saint Barthélemy'
    }, {
      value: 'Saint Helena',
      label: 'Saint Helena'
    }, {
      value: 'Saint Kitts and Nevis',
      label: 'Saint Kitts and Nevis'
    }, {
      value: 'Saint Lucia',
      label: 'Saint Lucia'
    }, {
      value: 'Saint Martin',
      label: 'Saint Martin'
    }, {
      value: 'Saint Pierre and Miquelon',
      label: 'Saint Pierre and Miquelon'
    }, {
      value: 'Saint Vincent and the Grenadines',
      label: 'Saint Vincent and the Grenadines'
    }, {
      value: 'Samoa',
      label: 'Samoa'
    }, {
      value: 'San Marino',
      label: 'San Marino'
    }, {
      value: 'Saudi Arabia',
      label: 'Saudi Arabia'
    }, {
      value: 'Senegal',
      label: 'Senegal'
    }, {
      value: 'Serbia',
      label: 'Serbia'
    }, {
      value: 'Seychelles',
      label: 'Seychelles'
    }, {
      value: 'Sierra Leone',
      label: 'Sierra Leone'
    }, {
      value: 'Singapore',
      label: 'Singapore'
    }, {
      value: 'Sint Maarten',
      label: 'Sint Maarten'
    }, {
      value: 'Slovakia',
      label: 'Slovakia'
    }, {
      value: 'Slovenia',
      label: 'Slovenia'
    }, {
      value: 'Solomon Islands',
      label: 'Solomon Islands'
    }, {
      value: 'Somalia',
      label: 'Somalia'
    }, {
      value: 'South Africa',
      label: 'South Africa'
    }, {
      value: 'South Georgia and the South Sandwich Islands',
      label: 'South Georgia and the South Sandwich Islands'
    }, {
      value: 'South Korea',
      label: 'South Korea'
    }, {
      value: 'South Sudan',
      label: 'South Sudan'
    }, {
      value: 'Spain',
      label: 'Spain'
    }, {
      value: 'Sri Lanka',
      label: 'Sri Lanka'
    }, {
      value: 'Sudan',
      label: 'Sudan'
    }, {
      value: 'Suriname',
      label: 'Suriname'
    }, {
      value: 'Svalbard and Jan Mayen',
      label: 'Svalbard and Jan Mayen'
    }, {
      value: 'Swaziland',
      label: 'Swaziland'
    }, {
      value: 'Sweden',
      label: 'Sweden'
    }, {
      value: 'Switzerland',
      label: 'Switzerland'
    }, {
      value: 'Syria',
      label: 'Syria'
    }, {
      value: 'São Tomé and Príncipe',
      label: 'São Tomé and Príncipe'
    }, {
      value: 'Taiwan',
      label: 'Taiwan'
    }, {
      value: 'Tajikistan',
      label: 'Tajikistan'
    }, {
      value: 'Tanzania',
      label: 'Tanzania'
    }, {
      value: 'Thailand',
      label: 'Thailand'
    }, {
      value: 'Timor-Leste',
      label: 'Timor-Leste'
    }, {
      value: 'Togo',
      label: 'Togo'
    }, {
      value: 'Tokelau',
      label: 'Tokelau'
    }, {
      value: 'Tonga',
      label: 'Tonga'
    }, {
      value: 'Trinidad and Tobago',
      label: 'Trinidad and Tobago'
    }, {
      value: 'Tristan da Cunha',
      label: 'Tristan da Cunha'
    }, {
      value: 'Tunisia',
      label: 'Tunisia'
    }, {
      value: 'Turkey',
      label: 'Turkey'
    }, {
      value: 'Turkmenistan',
      label: 'Turkmenistan'
    }, {
      value: 'Turks and Caicos Islands',
      label: 'Turks and Caicos Islands'
    }, {
      value: 'Tuvalu',
      label: 'Tuvalu'
    }, {
      value: 'U.S. Outlying Islands',
      label: 'U.S. Outlying Islands'
    }, {
      value: 'U.S. Virgin Islands',
      label: 'U.S. Virgin Islands'
    }, {
      value: 'Uganda',
      label: 'Uganda'
    }, {
      value: 'Ukraine',
      label: 'Ukraine'
    }, {
      value: 'United Arab Emirates',
      label: 'United Arab Emirates'
    }, {
      value: 'United Kingdom',
      label: 'United Kingdom'
    }, {
      value: 'United States',
      label: 'United States'
    }, {
      value: 'Uruguay',
      label: 'Uruguay'
    }, {
      value: 'Uzbekistan',
      label: 'Uzbekistan'
    }, {
      value: 'Vanuatu',
      label: 'Vanuatu'
    }, {
      value: 'Vatican City',
      label: 'Vatican City'
    }, {
      value: 'Venezuela',
      label: 'Venezuela'
    }, {
      value: 'Vietnam',
      label: 'Vietnam'
    }, {
      value: 'Wallis and Futuna',
      label: 'Wallis and Futuna'
    }, {
      value: 'Western Sahara',
      label: 'Western Sahara'
    }, {
      value: 'Yemen',
      label: 'Yemen'
    }, {
      value: 'Zambia',
      label: 'Zambia'
    }, {
      value: 'Zimbabwe',
      label: 'Zimbabwe'
    }, {
      value: 'Åland Islands',
      label: 'Åland Islands'
    }];
    var classes = classNames('contact-form', this.props.className);
    var formLocations = this.props.formLocations;
    return /*#__PURE__*/React.createElement("section", {
      className: classes
    }, /*#__PURE__*/React.createElement(AvForm, {
      onValidSubmit: this.handleSubmit,
      ref: function ref(c) {
        return _this2.form = c;
      },
      encType: "multipart/form-data"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      lg: 2
    }, /*#__PURE__*/React.createElement(AvSelectField, {
      name: "Salutation",
      label: "Salutation",
      options: [{
        label: 'Mr.',
        value: 'Mr.'
      }, {
        label: 'Mrs.',
        value: 'Mrs.'
      }, {
        label: 'Ms.',
        value: 'Ms.'
      }, {
        label: 'Dr.',
        value: 'Dr.'
      }]
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      lg: 4
    }, /*#__PURE__*/React.createElement(AvField, {
      name: "FirstName",
      label: "First Name",
      labelClass: "is-required",
      errorMessage: "Please enter a first name",
      type: "text",
      required: true
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      lg: 6
    }, /*#__PURE__*/React.createElement(AvField, {
      name: "LastName",
      label: "Last Name",
      labelClass: "is-required",
      errorMessage: "Please enter a last name",
      type: "text",
      required: true
    })), /*#__PURE__*/React.createElement(Col, {
      className: "d-none"
    }, /*#__PURE__*/React.createElement(AvField, {
      name: "_age",
      label: "Age",
      type: "text"
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      lg: 6
    }, /*#__PURE__*/React.createElement(AvField, {
      name: "Address1",
      label: "Address 1",
      labelClass: "is-required",
      errorMessage: "Please enter an address",
      type: "text",
      required: true
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      lg: 6
    }, /*#__PURE__*/React.createElement(AvField, {
      name: "Address2",
      label: "Address 2",
      type: "text"
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      lg: 6
    }, /*#__PURE__*/React.createElement(AvField, {
      name: "City",
      label: "City",
      labelClass: "is-required",
      errorMessage: "Please enter a city",
      type: "text",
      required: true
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      lg: 6
    }, /*#__PURE__*/React.createElement(AvSelectField, {
      name: "State",
      label: "State/Province",
      labelClass: "is-required",
      options: orderBy(states, ['label']),
      errorMessage: "Please select a state",
      required: true
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      lg: 6
    }, /*#__PURE__*/React.createElement(AvField, {
      name: "Zip",
      label: "Zip/Postal Code",
      labelClass: "is-required",
      maxLength: "5",
      validate: {
        required: {
          value: true,
          errorMessage: 'Please enter a 5-digit zip code'
        },
        pattern: {
          value: /^\d{5}$/,
          errorMessage: 'Please enter a 5-digit zip code'
        }
      }
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      lg: 6
    }, /*#__PURE__*/React.createElement(AvSelectField, {
      name: "Country",
      label: "Country",
      labelClass: "is-required",
      options: orderBy(countries, ['label']),
      errorMessage: "Please select a country",
      required: true
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      lg: 6
    }, /*#__PURE__*/React.createElement(AvField, {
      name: "Email",
      label: "Email",
      labelClass: "is-required",
      placeholder: "example@domain.com",
      type: "email",
      validate: {
        required: {
          value: true,
          errorMessage: "Please enter a valid email, Ex. 'example@domain.com'"
        },
        email: {
          value: true,
          errorMessage: "Please enter a valid email, Ex. 'example@domain.com'"
        }
      }
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      lg: 6
    }, /*#__PURE__*/React.createElement(AvField, {
      name: "Phone",
      label: "Phone",
      labelClass: "is-required",
      placeholder: "+1 (555) 495-3947",
      maxLength: "17",
      type: "tel",
      validate: {
        required: {
          value: true,
          errorMessage: 'Please enter a valid phone number'
        },
        tel: {
          value: true,
          errorMessage: 'Please enter a valid phone number'
        }
      }
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      lg: 6
    }, /*#__PURE__*/React.createElement(AvField, {
      name: "Store",
      label: "Store Name"
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      lg: 6
    }, /*#__PURE__*/React.createElement(AvField, {
      name: "StoreLocation",
      label: "Store Address"
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      xl: 6
    }, /*#__PURE__*/React.createElement(AvField, {
      name: "Comment",
      errorMessage: "Please enter a question or comment",
      label: "Questions/Comments",
      type: "textarea",
      labelClass: "is-required",
      required: true
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      lg: 6
    }, formLocations && formLocations.length > 1 && /*#__PURE__*/React.createElement(AvSelectField, {
      name: "inquiryReason",
      label: "Reason for Inquiry",
      labelClass: "is-required",
      options: formLocations,
      errorMessage: "Please select a reason",
      required: true
    }), /*#__PURE__*/React.createElement(Label, {
      className: "contact-form__spacer-label d-none d-xl-block"
    }, "Product Information"), /*#__PURE__*/React.createElement("div", {
      className: "mb-3"
    }, /*#__PURE__*/React.createElement(AvField, {
      name: "SpecificProduct",
      label: "Please check here if you are contacting us about a specific product.",
      type: "checkbox",
      onClick: this.toggleSpecificProduct,
      tag: CustomInput
    })), /*#__PURE__*/React.createElement(Collapse, {
      isOpen: this.state.specificProduct
    }, /*#__PURE__*/React.createElement(AvGroup, null, /*#__PURE__*/React.createElement(Label, {
      for: "UpcCode",
      className: "is-required"
    }, "Upc Code"), /*#__PURE__*/React.createElement(Help, {
      id: "help-upc",
      className: "ml-1",
      body: /*#__PURE__*/React.createElement("img", {
        src: upcImage,
        alt: "Upc Code"
      }),
      color: this.props.buttonColor
    }), /*#__PURE__*/React.createElement(AvInput, {
      name: "UpcCode",
      id: "UpcCode",
      placeholder: "5340012345",
      maxLength: "15",
      validate: {
        required: {
          value: this.state.specificProduct
        },
        pattern: {
          value: /^\d{10,}$/
        }
      }
    }), /*#__PURE__*/React.createElement(AvFeedback, null, "Please enter a valid upc code")), /*#__PURE__*/React.createElement(AvGroup, null, /*#__PURE__*/React.createElement(Label, {
      for: "PackageDetails"
    }, "Package Details"), /*#__PURE__*/React.createElement(Help, {
      id: "help-package-details",
      className: "ml-1",
      body: /*#__PURE__*/React.createElement("img", {
        src: dateImage,
        alt: "Package Details"
      }),
      color: this.props.buttonColor
    }), /*#__PURE__*/React.createElement(AvInput, {
      id: "PackageDetails",
      name: "PackageDetails",
      label: "Package Details",
      placeholder: "Use By 06/21/2019",
      type: "text"
    })), /*#__PURE__*/React.createElement(AvGroup, null, /*#__PURE__*/React.createElement("div", {
      className: "contact-form__attachment"
    }, /*#__PURE__*/React.createElement(Label, null, "Attach Image/Pdf"), /*#__PURE__*/React.createElement(AvField, {
      tag: CustomInput,
      type: "file",
      id: "attachment",
      name: "attachment",
      onChange: this.handleFileUpload,
      accept: validFileTypes,
      validationEvent: "onChange",
      labelClass: "custom-file-label custom-file-label--overlay",
      groupAttrs: {
        className: 'position-relative'
      },
      helpMessage: "5MB max upload limit",
      label: /*#__PURE__*/React.createElement(React.Fragment, null, this.state.attachmentName, /*#__PURE__*/React.createElement(Label, {
        className: "custom-file-label__btn btn " + (this.props.buttonColor ? 'btn-' + this.props.buttonColor : ''),
        for: "attachment"
      }, /*#__PURE__*/React.createElement("span", null, "Browse"), /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }, /*#__PURE__*/React.createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0V0z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
      })))),
      validate: {
        attachment: this.validateAttachment
      }
    })))), /*#__PURE__*/React.createElement("div", {
      className: "mb-3"
    }, /*#__PURE__*/React.createElement(AvField, {
      name: "OptIn",
      label: "Please check here to receive updates on products, promotions, recipes, surveys and offers.",
      type: "checkbox",
      tag: CustomInput
    })))), /*#__PURE__*/React.createElement(Alert, {
      className: "contact-form__error my-3 text-center",
      color: "danger",
      isOpen: this.state.error,
      toggle: this.dismissError
    }, "There was an issue sending your message. Please try again."), /*#__PURE__*/React.createElement(Row, {
      className: "mt-4 justify-content-center"
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: this.state.submitting,
      color: this.props.buttonColor,
      className: "contact-form__submit px-5 py-2 position-relative"
    }, "Submit", this.state.submitting && /*#__PURE__*/React.createElement("span", {
      className: "contact-form__submit-spinner spinner-border spinner-border-sm position-absolute",
      role: "status"
    })))), /*#__PURE__*/React.createElement(Modal, {
      className: "contact-form__modal",
      contentClassName: "p-3",
      centered: true,
      isOpen: this.state.success,
      toggle: this.toggleModal
    }, /*#__PURE__*/React.createElement(ModalHeader, {
      tag: "h4",
      toggle: this.toggleModal
    }, "Thank you for contacting us!"), /*#__PURE__*/React.createElement(ModalBody, null, "Your message has been received and we will respond as soon as possible.")));
  };

  return ConsumerAffairsForm;
}(React.Component);

export { ConsumerAffairsForm as default };
ConsumerAffairsForm.defaultProps = {
  buttonColor: 'primary'
};